import router from '../../router/index'
import store from '../../store/index'
import {Toast} from 'vant'
import ls from 'local-storage'
import moment from 'moment'
import {isNumeric} from "vant/lib/utils/validate/number";

export default {
    /**
     * 验证是否为空
     * @param d
     * @returns {boolean}
     */
    isEmpty: function(d) {
        if (
            typeof (d) === 'undefined'
            || d === null
            || d === 'null'
            || d === 'NULL'
            || d === ''
            || d === 'undefined'
            || JSON.stringify(d) === '{}'
            || JSON.stringify(d) === '[]'
        ) {
            return true;
        } else {
            return false;
        }
    },
    /**
     * 去除对象中所含空值
     * @param obj
     * @returns {{}}
     */
    removeObjNullValue: function(obj){
        let new_obj = {};
        if(!this.isEmpty(obj)){
            for (let i in obj){
                if(!this.isEmpty(obj[i])) new_obj[i] = obj[i];
            }
        }
        return new_obj;
    },
    /**
     * 路由跳转
     * @param to
     * @param is_rep
     * @returns {boolean}
     */
    routerTo: function(to, is_rep) {
        if(this.isEmpty(is_rep)) is_rep = false;
        if(this.isEmpty(to)) {
            Toast('暂无下级功能页');
            return false;
        }
        if(is_rep){
            router.replace(to);
        }else{
            router.push(to);
        }
    },
    /**
     * 路由跳转
     * @param name
     * @param params
     * @param query
     * @param is_rep
     * @returns {boolean}
     */
    routerToName: function(name, params, query, is_rep) {
        if(this.isEmpty(is_rep)) is_rep = false;
        if(this.isEmpty(name)) {
            Toast('下级功能页制作中，请稍等');
            return false;
        }

        this.routerTo({name, params, query}, is_rep);
    },
    /**
     * 路由返回
     */
    routerBack: function() {
        router.back();
    },
    /**
     * 时间格式化操作
     * @param format
     * @param date
     */
    dateFormat: function(format, date){
        if(this.isEmpty(date)){
            date = undefined;
        }else if(isNumeric(date)){
            if(date.length < 13) date += '000';
            date = parseInt(date);
        }
        let obj = this.$moment(date);
        return obj.format(format);
    },
    /**
     * IOS错位问题
     */
    iosDislocation: function (){
        setTimeout(function() {
            var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
            window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        }, 100);
    },
    $toast: Toast,
    $store: store,
    $router: router,
    $wx: require('weixin-js-sdk'),
    $ls: ls,
    $moment: moment
}
